import { render, staticRenderFns } from "./companyEdit-Panel.vue?vue&type=template&id=52427435&lang=pug&"
import script from "./companyEdit-Panel.vue?vue&type=script&lang=js&"
export * from "./companyEdit-Panel.vue?vue&type=script&lang=js&"
import style0 from "./companyEdit-Panel.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports